import { apiSlice } from "../../api/ApiService";
import { getHeadersFromRedux } from "../../utility/functions/common-functions";

const savePreferredLangApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    PreferredLang: builder.mutation({
      query: ({ body }) => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/PatientPreference/preferred-language`,
          method: "POST",
          data: body,
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { usePreferredLangMutation } = savePreferredLangApi;
export default savePreferredLangApi;
